<template>
    <div>
        <div class="input-group input-group-sm">
            <b-input-group>
                <b-input-group-prepend is-text>
                    <i class="fas fa-briefcase"></i>
                </b-input-group-prepend>
                <b-form-input data-hj-whitelist id="company" class="form-control" v-model="organisationText" readonly></b-form-input>
                <b-input-group-append>
                    <b-button variant="outline-primary" v-b-modal="'form-view-company'" v-shortkey="{openAfasCompanyModel: ['o']}" @shortkey="keyDown" :hidden="hideSelect">Selecteer</b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <b-modal
                @shown="show"
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="true"
                :lazy="true"
                :ref="'form-view-company'"
                :id="'form-view-company'"
                title="Organisatie selecteren"
                size="xl"
                scrollable>
            <div>
                <div class="input-group">
                    <input data-hj-whitelist class="form-control" type="search" ref="companySearchField" v-model="q" placeholder="E-mailadres, bedrijfsnaam e.d." @keyup.enter="search(q)" aria-label="Search">
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary" @click="search(q)" type="submit">Zoeken</button>
                    </div>
                </div>

                <div class="detail-list mt-2">
                    <div class="d-flex mt-3 mb-3 justify-content-between">
                        <div class="text-muted m-auto justify-content-center">
                            <small v-if="loaded!==null">
                                <a class="refresh force" @click="refresh()"><em class="fa fa-sync"></em> <timeago :since="loaded":auto-update="30"></timeago> bijgewerkt</a>
                            </small>
                            <small v-if="loaded===null">
                                <em class="fa fa-sync fa-spin"></em> Bezig met ophalen van resultaten
                            </small>
                        </div>
                    </div>

                    <strong>Resultaten:</strong>

                    <div class="result-header" v-if="results.length >0">
                        <div class="list-group list-group-flush mr-3">
                            <div class="list-group-item">
                                <div class="text-sm-left d-flex justify-content-between align-items-center">
                                    <div style="flex-grow: 2; flex-basis:0;"><strong>T</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;"><strong>Naam</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;"><strong>E-mailadres</strong></div>
                                    <div style="flex-grow: 5; flex-basis:0;"><strong>Telefoonnummer</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="results">
                        <div class="list-group list-group-flush">

                            <a @click="select(result)" v-for="result in results" class="list-group-item" :key="result.id">

                                <div class="d-flex justify-content-between align-items-center text-sm-left">
                                    <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;">{{result.name ? result.name : '-'}}</div>
                                    <div style="flex-grow: 10; flex-basis:0;">{{result.email ? result.email : '-'}}</div>
                                    <div style="flex-grow: 5; flex-basis:0;">{{result.tel ? result.tel : '-'}}</div>
                                    <div>
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>

            </div>
            <div slot="modal-footer" class="w-100">
                <button class="btn btn-outline btn-outline-primary" @click="openCreateModal()">
                    <i class="fas fa-plus-circle"></i> Nieuwe organisatie toevoegen
                </button>
                <button class="btn btn-light float-right" @click="hide">
                    Sluiten
                </button>
            </div>
        </b-modal>
        <afas-company-create ref="create-form" :form="form" :selected="selectedOrg" @finished="select"></afas-company-create>
    </div>
</template>

<script>
    import afasCompanyCreate from './afasCompanyCreate';

    export default {
        components: {
            afasCompanyCreate
        },
        data() {
            return {
                results: [],

                loaded: null,

                errors: [],

                q: '',

                selectedOrg: null
            }
        },
        props: {
            value: {
                type: Object | Array
            },
            form: {
                type: Object,
                required: true,
            },
            hideSelect : {
                type: Boolean,
                default: false
            }
        },
        watch: {

        },
        mounted() {
            this.search(this.q);
        },
        computed: {
            organisationText() {
                if(!this.value) {
                    return '';
                }

                return [this.value.name, this.value.email, this.value.tel].join('; ');
            }
        },
        methods: {
            hide() {
                this.q = '';
                this.$refs['form-view-company'].hide();
            },
            show(model) {
                this.$root.modelOpen = model.target.id;
                this.$refs.companySearchField.focus();
            },
            search(q) {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.post('/api/v1/leads/afas/relation/find', {
                    q: q
                })
                    .then(response => {
                        this.results = response.data;
                        this.loaded = new Date();
                    })
                    .catch(error => {
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                        this.loaded = new Date();
                    });
            },
            refresh() {
                this.search(this.q);
            },
            select(result) {
                if (result && result.is_valid && result.is_valid === true) {
                    this.$emit('input', result);
                    this.hide();

                    this.$parent.$refs.afasContactInput.$refs['form-view-contact'].show()
                    return;
                }

                // When there's no address, show the company create/update form to allow address to be filled.
                this.$refs['create-form'].show(result);
            },
            openCreateModal() {
                this.$refs['create-form'].show();
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'openAfasCompanyModel':
                        this.$refs['form-view-company'].show();
                    break;
                }
            }
        }
    }
</script>